import * as Scrivito from 'scrivito';
import { FormSpecialSubmissionErrorWidgetAttributes } from '../form-special-submission-error-widget';
import { FormWidgetAttributes } from './form-widget-definitions';
import { getServerValidationLocalizedErrorMessages, ServerValidation } from './formik-helper/formik-validation';

export const FORM_SUBMISSION_UNKNOWN_ERROR_MESSAGE = 'Ein unbekannter Fehler ist aufgetreten.';
export const FORM_SUBMISSION_NETWORK_ERROR_MESSAGE = 'Ein Netzwerkfehler ist aufgetreten';

export function getDefaultSubmissionError(widget: Scrivito.Widget): string {
  return (
    (widget.get(FormWidgetAttributes.SUBMISSION_ERROR) as string) ||
    (widget.get(FormWidgetAttributes.ERROR_MESSAGE) as string) ||
    'Ein Fehler ist aufgetreten.'
  );
}

export function extractServerErrorDetails(serverValidation: ServerValidation): string | undefined {
  const topLevelMessage = serverValidation.localizedMessage || serverValidation.message;
  if (topLevelMessage?.trim()) {
    return topLevelMessage.trim();
  }

  const fieldErrors = getServerValidationLocalizedErrorMessages(serverValidation);
  const messages = Object.values(fieldErrors).filter((message) => !!message?.trim());

  if (messages.length === 1) {
    return messages[0];
  }

  if (messages.length > 1) {
    return messages.join(' / ');
  }

  return undefined;
}

export function getSubmissionErrorMessage(widget: Scrivito.Widget, submissionErrorDetails: string | undefined): string {
  const defaultError = getDefaultSubmissionError(widget);

  if (!submissionErrorDetails) {
    return defaultError;
  }

  const specialErrors = widget.get(FormWidgetAttributes.SPECIAL_SUBMISSION_ERRORS) as Scrivito.Widget[] | null;
  if (specialErrors?.length) {
    for (const specialErrorWidget of specialErrors) {
      const triggeringMessage = specialErrorWidget.get(
        FormSpecialSubmissionErrorWidgetAttributes.TRIGGERING_ERROR_MESSAGE
      ) as string;

      if (triggeringMessage === submissionErrorDetails) {
        const specialError = specialErrorWidget.get(
          FormSpecialSubmissionErrorWidgetAttributes.RESULTING_SPECIAL_ERROR
        ) as string;
        return specialError || defaultError;
      }
    }
  }

  return submissionErrorDetails;
}
